import React from 'react';
import { css } from 'react-emotion';
import PropTypes from 'prop-types';
import { CommentChat } from 'react-cimpress-comment';
import { auth } from '../../utils/auth';

const commentsBoxStyle = css`
  padding: 15px 15px 5px;
  border: 1px solid #c4cdd6;
  background: #fff;
  display: flex;
  overflow-y: auto;
  flex-direction: column;
  flex: 1;
  position: relative;
  min-height: 140px;
  max-height: 400px;
`;

const termSectionTitleStyle = css`
  border-bottom: 1px solid lightgray;
  margin-bottom: 15px;
  padding-bottom: 5px;
`;

const CommentsWrapper = ({ termId }) => {
  const termResourceUrl = `${process.env.REACT_APP_PRICING_TERM_URL}/api/v0/terms/${termId}/revisions`;

  return (
    <div className="col-xs-12">
      <h5 className={`${termSectionTitleStyle}`}>
        <span className="h5">Comments</span>
      </h5>
      <div className={`${commentsBoxStyle}`}>
        <CommentChat
          resourceUri={termResourceUrl}
          newestFirst
          editComments
          autoFocus={false}
          accessToken={auth.getAccessToken()}
          enforceVisibilityLevel="internal"
          showVisibilityLevels={false}
        />
      </div>
    </div>
  );
};

CommentsWrapper.propTypes = {
  termId: PropTypes.string.isRequired
};

export default CommentsWrapper;
